import { connect } from 'react-redux';
import { userClickedInventoryLinkAction } from 'swag-client-common/redux/analytics/analytics.actions';
import { OtherLinks as OtherLinksComponent } from './other-links';
const mapDispatchToProps = dispatch => ({
  userClickedInventoryLink: () => {
    dispatch(userClickedInventoryLinkAction());
  }
});
export const OtherLinks = connect(null, mapDispatchToProps)(OtherLinksComponent);